export default {
  list: ({ networkId, showId }) =>
    showId ? ['networkId', networkId, 'showId', showId] : ['networkId', networkId],
};
